{
  "name": "selectfi-widget-sdk",
  "version": "1.1.11",
  "description": "A browser-based SDK for serving widgets to third-party sites",
  "main": "dist/selectfi-widget-sdk.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "build:prod": "NODE_ENV=production tsup",
    "dev": "open test.html && tsup --watch",
    "test": "vitest --run",
    "test:coverage": "vitest --run --coverage",
    "test:watch": "vitest",
    "test:ui": "vitest --ui",
    "lint": "tsc --noEmit",
    "clean": "rm -rf dist",
    "analyze": "NODE_ENV=production tsup --metafile && npm run analyze:visualize",
    "analyze:visualize": "npx esbuild-visualizer --metadata dist/metafile-*.json --filename dist/bundle-report.html --open"
  },
  "keywords": [
    "widget",
    "sdk",
    "browser",
    "javascript",
    "typescript",
    "selectfi"
  ],
  "author": "selectfi",
  "license": "UNLICENSED",
  "private": true,
  "type": "module",
  "devDependencies": {
    "@types/node": "^22.0.0",
    "@vitest/ui": "^4.0.17",
    "@vitest/coverage-v8": "^4.0.17",
    "esbuild-visualizer": "^0.7.0",
    "jsdom": "^27.4.0",
    "tsup": "^8.5.1",
    "tsx": "^4.0.0",
    "typescript": "^5.9.3",
    "vitest": "^4.0.17"
  },
  "browserslist": [
    "defaults",
    "not IE 11"
  ],
  "allowScripts": {
    "fsevents@2.3.3": true
  }
}
